(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function isVerticalThumbSlider(sliderEl) {
    return (
      sliderEl &&
      sliderEl.classList.contains('thumbnail-slider--with-arrows') &&
      sliderEl.closest('.media-gallery--thumbs-left') &&
      DESKTOP_MQ.matches
    );
  }

  function getThumbList(sliderEl) {
    return sliderEl.querySelector('.thumbnail-list');
  }

  function updateVerticalThumbArrows(sliderEl, list) {
    var prev = sliderEl.querySelector('button[name="previous"]');
    var next = sliderEl.querySelector('button[name="next"]');
    if (!prev || !next || !list) return;

    var canScroll = list.scrollHeight > list.clientHeight + 4;

    if (!canScroll) {
      prev.setAttribute('disabled', 'disabled');
      next.setAttribute('disabled', 'disabled');
      return;
    }

    if (list.scrollTop <= 4) {
      prev.setAttribute('disabled', 'disabled');
    } else {
      prev.removeAttribute('disabled');
    }

    if (list.scrollTop + list.clientHeight >= list.scrollHeight - 4) {
      next.setAttribute('disabled', 'disabled');
    } else {
      next.removeAttribute('disabled');
    }
  }

  function scrollThumbList(sliderEl, list, direction) {
    var item = list.querySelector('.thumbnail-list__item');
    var gap = 8;
    var step = ((item ? item.offsetHeight || item.offsetWidth : 72) + gap) * direction;

    if (isVerticalThumbSlider(sliderEl)) {
      list.scrollBy({ top: step, behavior: 'smooth' });
    } else {
      list.scrollBy({ left: step, behavior: 'smooth' });
    }

    window.setTimeout(function () {
      updateVerticalThumbArrows(sliderEl, list);
    }, 400);
  }

  function handleArrowClick(event) {
    var btn = event.target.closest('.thumbnail-slider__arrow');
    if (!btn) return;

    var sliderEl = btn.closest('.thumbnail-slider--with-arrows');
    if (!sliderEl) return;

    var list = getThumbList(sliderEl);
    if (!list) return;

    if (isVerticalThumbSlider(sliderEl)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var direction = btn.getAttribute('name') === 'next' ? 1 : -1;
      scrollThumbList(sliderEl, list, direction);
    }
  }

  function initThumbnailSlider(sliderEl) {
    if (!sliderEl || sliderEl.dataset.brandThumbsReady === 'true') return;
    sliderEl.dataset.brandThumbsReady = 'true';

    var list = getThumbList(sliderEl);
    if (!list) return;

    list.addEventListener('scroll', function () {
      if (isVerticalThumbSlider(sliderEl)) {
        updateVerticalThumbArrows(sliderEl, list);
      }
    });

    if (isVerticalThumbSlider(sliderEl)) {
      window.setTimeout(function () {
        updateVerticalThumbArrows(sliderEl, list);
      }, 100);
      window.setTimeout(function () {
        updateVerticalThumbArrows(sliderEl, list);
      }, 800);
    }
  }

  function patchSliderComponent() {
    var SliderComponent = customElements.get('slider-component');
    if (!SliderComponent || SliderComponent.prototype.__brandGalleryPatched) return;
    SliderComponent.prototype.__brandGalleryPatched = true;

    var originalInitPages = SliderComponent.prototype.initPages;
    var originalUpdate = SliderComponent.prototype.update;
    var originalOnButtonClick = SliderComponent.prototype.onButtonClick;

    SliderComponent.prototype.initPages = function () {
      var list = getThumbList(this);
      if (isVerticalThumbSlider(this) && list) {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
          return el.clientWidth > 0;
        });
        updateVerticalThumbArrows(this, list);
        return;
      }
      return originalInitPages.call(this);
    };

    SliderComponent.prototype.update = function () {
      var list = getThumbList(this);
      if (isVerticalThumbSlider(this) && list) {
        updateVerticalThumbArrows(this, list);
        return;
      }
      return originalUpdate.call(this);
    };

    SliderComponent.prototype.onButtonClick = function (event) {
      var list = getThumbList(this);
      if (isVerticalThumbSlider(this) && list) {
        event.preventDefault();
        var direction = event.currentTarget.getAttribute('name') === 'next' ? 1 : -1;
        scrollThumbList(this, list, direction);
        return;
      }
      return originalOnButtonClick.call(this, event);
    };
  }

  function boot(root) {
    patchSliderComponent();
    (root || document).querySelectorAll('.thumbnail-slider--with-arrows').forEach(initThumbnailSlider);
  }

  document.addEventListener('click', handleArrowClick, true);

  function patchWhenReady() {
    if (!customElements.get('slider-component')) {
      window.requestAnimationFrame(patchWhenReady);
      return;
    }
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchWhenReady);
  } else {
    patchWhenReady();
  }

  window.addEventListener('load', function () {
    boot();
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  DESKTOP_MQ.addEventListener('change', function () {
    document.querySelectorAll('.thumbnail-slider--with-arrows').forEach(function (slider) {
      slider.dataset.brandThumbsReady = 'false';
    });
    boot();
  });
})();
